module.exports = __webpack_public_path__ + "static/img/zhenhousuifang@3x.90da86a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bingchengguanli/zhenhousuifang@3x.png
// module id = dN2S
// module chunks = 1